import { IAddress } from '../../../Spaces/Address/types';
import { TSpace } from '../../../Spaces/Space';
import { GroupSelection } from '../../GroupSelection';

export type TP_Building =  {
    buildingType: BuildingType;
    squereMeter: number;
    showLocation:boolean;
    showEOV:boolean;
    showGroupInOP:GroupSelection;
    isOn: boolean;
    isMan: boolean;
    errSum: boolean;
    address: IAddress;
    currencyCode: string | undefined;
    isOnboarding: boolean,
} & TSpace


export const schema = 'AutomationApps.Plants.Buildings.P_Building';
export const modelId = 'dtmi:AutomationApps:Plants:Buildings:P_Building';

export enum BuildingType {
    Office = 0, //0
    Hotel = 1, //1 
    Hospital = 2, //2 
    Educational = 3, //3 
    ShoppingMall = 4, //4 
    Institutional  = 5, //5
    Assembly  = 6, //6
    Storage   = 7, //6
    Industrial = 8, // 8
    Living = 9, // 9
    AssistedLiving = 10, // 10
    EventHalls = 11, // 11
    SportHalls = 12, // 12
}
 